<template>
  <div>
    <footer>
      <div class="footer_center">
        <div class="container">
          <!-- web 端样式 -->
          <div class="footer_center_left">
            <div class="footer_top">
              At a glance
            </div>
            <dl>
              <dt><span>About us</span></dt>
              <dd><router-link to="/Who-we-are">Who we are </router-link></dd>
              <dd>
                <router-link to="/Our-responsibility"
                  >Our Responsibility</router-link
                >
              </dd>
              <dd>
                <router-link to="/Why-choose-us">Why Choose us </router-link>
              </dd>
            </dl>
            <dl>
              <dt><span>Company Strength</span></dt>
              <dd>
                <router-link to="/Production-capacity"
                  >Production capacity</router-link
                >
              </dd>
              <dd>
                <router-link to="/Research-ability"
                  >Research ability</router-link
                >
              </dd>
            </dl>

            <dl>
              <dt><span>Products</span></dt>
              <dd>
                <router-link to="/Welding-wire">Welding wire</router-link>
              </dd>
              <dd>
                <router-link to="/coo">CCO plate</router-link>
              </dd>
              <!-- <dd ><router-link to="/nihard">High Chromium White Cast Iron</router-link></dd>
		                    <dd ><router-link to="/wear">Wear resistant ceramics</router-link></dd>
		                    -->
              <dd>
                <router-link to="/product/Overlay-Wear-Pipe"
                  >Overlay Wear Pipe</router-link
                >
              </dd>
              <dd><router-link to="/Wear-parts">Wear parts</router-link></dd>
              <!-- <dd ><router-link to="/detail?id=24">AR steel plate </router-link></dd> -->
            </dl>
            <dl>
              <dt><span>Applications</span></dt>
              <dd><router-link to="/appliction/mining">Mining</router-link></dd>
              <dd>
                <router-link to="/appliction/cement-plant"
                  >Cement Plant</router-link
                >
              </dd>
              <dd>
                <router-link to="/appliction/power-plant"
                  >Power Plant</router-link
                >
              </dd>
              <dd><router-link to="/appliction/port">Port</router-link></dd>
              <dd>
                <router-link to="/appliction/steel-mill"
                  >Steel Mill</router-link
                >
              </dd>
              <dd>
                <router-link to="/appliction/bulk-material-handling"
                  >Bulk Material Handling</router-link
                >
              </dd>
            </dl>
          </div>
          <!-- 移动端样式 -->
          <Menu />
          <div class="footer_center_right">
            <div class="footer_top">
              Contact
            </div>
            <div class="footer-contact">
              <dl>
                <dt><span>Call us</span></dt>
                <dd><a href="tel:86 22 84776558">+86 22 84776558</a></dd>
              </dl>
              <dl>
                <dt><span>Send us a message</span></dt>
                <dd><a href="mailto:HS@Hisantech.com">HS@Hisantech.com</a></dd>
              </dl>
            </div>
            <input
              type="text"
              class="input_address"
              v-model="useremail"
              placeholder="Enter your email address"
            />
            <div class="submit" @click="submitemail()">
              Submit
              <img src="../assets/images/icon/right.png" alt="" class="right" />
            </div>
            <!-- <img src="../assets/images/header/submit.png" alt="" class="" @click="submitemail()"> -->
            <ul class="lx_icon_box">
              <!-- <li>
                <a href="">
                  <img
                    src="../assets/images/icon/facebook.png"
                    alt=""
                    srcset=""
                    class="icon1"
                  />
                  <img
                    src="../assets/images/icon/facebook1.png"
                    alt=""
                    srcset=""
                    class="icon1"
                  />
                </a>
              </li>
              <li>
                <a href="">
                  <img
                    src="../assets/images/icon/whatsapp.png"
                    alt=""
                    srcset=""
                    class="icon2"
                  />
                  <img
                    src="../assets/images/icon/whatsapp1.png"
                    alt=""
                    srcset=""
                    class="icon2"
                  />
                </a>
              </li> -->
              <li>
                <a
                  href="https://www.linkedin.com/company/hisan-tianjin-co-ltd/"
                >
                  <img
                    src="../assets/images/icon/in.png"
                    alt=""
                    srcset=""
                    class="icon3"
                  />
                  <img
                    src="../assets/images/icon/in1.png"
                    alt=""
                    srcset=""
                    class="icon3"
                  />
                </a>
              </li>
              <li>
                <a href="">
                  <img
                    src="../assets/images/icon/telegram-plane.png"
                    alt=""
                    srcset=""
                    class="icon4"
                  />
                  <img
                    src="../assets/images/icon/telegram-plane1.png"
                    alt=""
                    srcset=""
                    class="icon4"
                  />
                </a>
              </li>
              <!-- <li>
                <a href="">
                  <img
                    src="../assets/images/icon/skype.png"
                    alt=""
                    srcset=""
                    class="icon5"
                  />
                  <img
                    src="../assets/images/icon/skype1.png"
                    alt=""
                    srcset=""
                    class="icon5"
                  />
                </a>
              </li> -->
              <li>
                <a href="">
                  <img
                    src="../assets/images/icon/vk.png"
                    alt=""
                    srcset=""
                    class="icon6"
                  />
                  <img
                    src="../assets/images/icon/vk1.png"
                    alt=""
                    srcset=""
                    class="icon6"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer_bottom">
        <div class="container">
          <img src="../assets/images/header/logo3.png" alt="" class="logo2" />
          <p>
            © Copyright - 2020-2023: All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import Menu from "./menu.vue";
export default {
  components: {
    Menu,
  },
  data() {
    return {
      useremail: "",
    };
  },
  methods: {
    isValidEmail(email) {
      const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return regex.test(email);
    },
    submitemail() {
      if (this.useremail == "" && this.isValidEmail(this.useremail)) {
        alert("Enter your email address");
      } else {
        console.log(this.useremail);
        axios({
          method: "post",
          url: `${this.$apiYf}/liuyan2api.php`,
          data: {
            email: this.useremail,
          },
          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          alert(res.data.des);
        });
      }
    },
  },
};
</script>

<style scoped></style>e
